
export const notification = (state) => { return state.notification };
export const validateNotification = (state) => { return state.validateNotification };
